/** @file Keeps one Map identity per role while its entries (and their order) stay the same. */

function sameEntries(a: Map<string, number>, b: Map<string, number>): boolean {
  if (a.size !== b.size) return false;
  const other = b.entries();
  for (const [key, value] of a) {
    const next = other.next();
    if (next.done === true || next.value[0] !== key || next.value[1] !== value) return false;
  }
  return true;
}

// `map` becomes the stored map of `role` unless the stored one has the same entries in the same order. The last
// input per role is remembered under `<role><`, so a map seen just before is not compared again.
/** The stored map of `role` when `map` has equal entries in equal order, else `map` (stored from now on). */
export function canonicalMap(store: Map<string, Map<string, number>>, role: string, map: Map<string, number>): Map<string, number> {
  const canon = store.get(role);
  if (canon === map) return map;
  const inputKey = `${role}<`;
  if (canon !== undefined && store.get(inputKey) === map) return canon;
  store.set(inputKey, map);
  if (canon !== undefined && sameEntries(canon, map)) return canon;
  store.set(role, map);
  return map;
}
